import IconButton from "@mui/material/IconButton";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import classesCss from './DrawerItem.module.css';

const DrawerItem = ({text, type="drop", cb=()=>{}, url="#"}) => {
    return (
        type === "drop" ?
            <div className={classesCss.drawer__item} onClick={() => {
                document.getElementById("header__drawer__page").style.transform = "scaleX(1)";
                cb(text);
            }}>
                <p>{text}</p>
                <IconButton>
                    <ArrowForwardIosIcon sx={{
                        fontSize: '16px',
                    }}/>
                </IconButton>
            </div> :
            <div className={classesCss.drawer__item}>
                <a href={url}>{text}</a>
            </div>

    )
};

export default DrawerItem;